export default __webpack_public_path__ + "static/media/bg-8.2579fe45.png";